let articleVideoLoaded = false;

function initDisplayArticleVideo() {
  const articleVideo = document.getElementById('article-video');

  
  if(!articleVideoLoaded && (!articleVideo || !window.VidyardV4)) {
    return;
  }
  
  const vidyard_id = articleVideo.dataset.articleVideo;
  
  window.onVidyardAPI = (vidyardEmbed) => {
    console.log(vidyardEmbed);
    vidyardEmbed.api.addReadyListener((_, player) => {
      setupTriggers(articleVideo.dataset.articleVideo);

      const articleImageHolder = document.getElementById('article-image-holder');
      articleImageHolder?.classList.remove('loading');
      articleVideoLoaded = true;
    }, vidyard_id);
  }
}

function setupTriggers(vidyard_id) {
  const triggers = document.querySelectorAll(`[href="#${vidyard_id}"]`);

  for(let trigger of triggers) {
    trigger.classList.remove('loading');

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const articleImage = document.getElementById('article-image');
      const articleVideo = document.getElementById('article-video');

      articleImage?.classList.add('hide');
      articleVideo?.classList.add('show');


      var players = window.VidyardV4.api.getPlayersByUUID(vidyard_id);
      if(players.length > 0 && players[0].ready()) {
        players[0].play();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initDisplayArticleVideo);
window.addEventListener('load', initDisplayArticleVideo);
